export const LICENSE_PRODUCT_MAP = {
    frontlayer: "frontlayer",
    "hospitality-tv": "frontlayer",
    "guest-tv": "frontlayer",
    foyer: "frontlayer",
    "streaming-tv": "streaming-tv",
    channels: "streaming-tv",
    signage: "signage",
    promotions: "promotions",
    offers: "promotions",
    care: "care",
    "video-call": "video-call",
};
export function productsFromLicenses(raw) {
    const out = new Set();
    for (const value of raw) {
        const mapped = LICENSE_PRODUCT_MAP[value];
        if (mapped)
            out.add(mapped);
    }
    return out;
}
export const SIGNAGE_LIVE_TV_PRODUCTS = [
    "signage",
    "streaming-tv",
];
export function getsEffectChannels(products) {
    return products.has("signage");
}
export function getsEffectChannelsFromLicenses(products) {
    if (!products)
        return false;
    return getsEffectChannels(productsFromLicenses(products));
}
export function canPlaceLiveTvOnSignage(products) {
    return SIGNAGE_LIVE_TV_PRODUCTS.every((p) => products.has(p));
}
export function canPlaceLiveTvOnSignageFromLicenses(products) {
    if (!products)
        return false;
    return canPlaceLiveTvOnSignage(productsFromLicenses(products));
}
export function hasPromotionsLicense(products) {
    if (!products)
        return false;
    return productsFromLicenses(products).has("promotions");
}
export function hasStreamingTvLicense(products) {
    if (!products)
        return false;
    return productsFromLicenses(products).has("streaming-tv");
}
